import { Link } from "react-router-dom";
import { NAV, FOOTER_NAV } from "../../lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/8 bg-[#060A26]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12">
        <div>
          <Link to="/" className="inline-block">
            <img src="/partecon-logo.png" alt="PARTECON — The School OS" className="h-20 w-auto" />
          </Link>
          <p className="text-white/50 mt-5 max-w-sm leading-relaxed text-sm">
            The School Operating System. One live, governed operating layer connecting principals,
            teachers, students, parents and administrators on the same real-time data.
          </p>
          <Link to="/contact" data-testid="footer-contact-link" className="inline-flex items-center gap-1.5 text-sm text-[#F1BF26] hover:text-[#F5B93C] mt-6 font-medium">
            Talk to PARTECON <span aria-hidden="true">→</span>
          </Link>
        </div>
        <div>
          <p className="overline overline-light mb-5">Platform</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-white/55 hover:text-white transition-colors text-sm">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="overline overline-light mb-5">More</p>
          <ul className="space-y-3">
            {FOOTER_NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-white/55 hover:text-white transition-colors text-sm" data-testid={`footer-link-${n.to.slice(1)}`}>{n.label}</Link>
              </li>
            ))}
            <li><a href="mailto:aleem@partecon.com" className="text-white/55 hover:text-white transition-colors text-sm">aleem@partecon.com</a></li>
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-white/8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/40 font-mono-accent">
        <span>© {new Date().getFullYear()} PARTECON Private Limited. All rights reserved.</span>
        <span className="uppercase tracking-widest">The School Operating System</span>
      </div>
    </div>
  </footer>
);
